export default class AlSelectizeController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.model = null;
        this.disabled = false;
        this.items = [];
        this.selectizeOptions = null;
        this.onChange = null;

        this.defaultSelectizeOptions = {
            maxItems: 1,
            delimiter: '##--..--##',
            valueField: 'value',
            labelField: 'label',
            searchField: 'label',
            sortField: 'label'
        };

        this.selectizeInstance = null;
    }

    $onInit() {
        this._initWatchers();
    }

    $postLink() {
        this._initializeSelectize();
    }

    $onDestroy() {
        if (this.selectizeInstance) {
            this.selectizeInstance.destroy();
        }
    }

    _initializeSelectize() {
        const options = this._getCurrentSelectizeOptions();
        options.options = _.cloneDeep(this.items);

        this.selectizeInstance = this.element.find('select').selectize(options)[0].selectize;
        this.selectizeInstance.setValue(this.model);

        this.selectizeInstance.on('change', (val) => {
            if (!_.isEqual(this.model, val)) {
                this.onChange({
                    value: val
                })
            }
        });
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.disabled,
            (disabled) => {
                if (this.selectizeInstance) {
                    disabled ? this.selectizeInstance.disable() : this.selectizeInstance.enable();
                }
            }
        )

        this.scope.$watch(
            () => this.model,
            (newVal) => {
                if (this.selectizeInstance) {
                    this.selectizeInstance.setValue(this.model);
                }
            }
        )

        this.scope.$watch(
            () => this.items,
            (newVal) => {
                if (this.selectizeInstance) {
                    this.selectizeInstance.addOption(newVal);
                    this.selectizeInstance.setValue(this.model);
                }
            }
        )
    }

    _getCurrentSelectizeOptions() {
        const out = _.defaults(this.selectizeOptions, this.defaultSelectizeOptions);

        if (!out.placeholder) {
            out.placeholder = (out.maxItems !== 1) ? 'Select one or more' : 'Select one';
        }

        return out;
    }
}

AlSelectizeController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-selectize/controller.js